/**
 * map of category path -> pinterest board id
 * keep keys in the same canonical form that getCategoryPathByTitle returns
 */
const CATEGORY_PATH_TO_BOARD_ID = {
    "classic-rock": "1000643679646937843",
    country: "1000643679647005475",
    latin: "1000643679647005473",
    rnb: "1000643679647006985",
    folk: "1000643679647005479",
    "hip-hop": "1000643679647005478",
    "60s": "1000643679647005471",
    "70s": "1000643679647005472",
    "80s": "1000643679647005295",
    "90s": "1000643679647005467",
    "2000s": "1000643679647005469",
    pop: "1000643679645850903",
    alternative: "1000643679647005482",
    "new-wave": "1000643679647005477",
    "hard-rock": "1000643679647005294",
    "k-pop": "1000643679647005483",
    popular: "1000643679647005480",
    metal: "1000643679647164084",
    "soft-rock": "1000643679647164095",
    disco: "1000643679647164097",
    indie: "1000643679647163706",
    electronic: "1000643679647163710",
    punk: "1000643679647163705",
    oldies: "1000643679647168190",
    jazz: "1000643679647164096"
};



export const getPinterestBoardIdByTitle = (title) => {

    if (!title) return undefined;
    const categoryPath = getCategoryPathByTitle(title);
    if (!categoryPath) return undefined;
    return CATEGORY_PATH_TO_BOARD_ID[categoryPath];
};



export const getCategoryPathByTitle = (title) => {

    let path;
    // potentially multiple identifiers for each category, one coming from last.fm tags, the other coming from url title
    switch (title) {

        case 'classic-rock':
        case 'classic rock':

            path = 'classic-rock';
            break;

        case 'country':
            path = 'country';
            break;

        case 'latin':
            path = 'latin';
            break;

        case 'rnb':
            path = 'rnb';
            break;

        case 'folk':
            path = 'folk';
            break;

        case 'hip-hop':
        case 'hip hop':
            path = 'hip-hop';
            break;

        case '60s':
            path = '60s';
            break;

        case '70s':
            path = '70s';
            break;

        case '80s':
            path = '80s';
            break;

        case '90s':
            path = '90s';
            break;

        case '2000s':
        case '00s':
            path = '2000s';
            break;

        case 'pop':
            path = 'pop';
            break;

        case 'alternative':
            path = 'alternative';
            break;

        case 'new-wave':
        case 'new wave':
            path = 'new-wave';
            break;

        case 'soft-rock':
        case 'soft rock':
            path = 'soft-rock';
            break;

        case 'hard-rock':
        case 'hard rock':
            path = 'hard-rock';
            break;

        case 'k-pop':
            path = 'k-pop';
            break;

        case 'movies':
            path = 'movies';
            break;

        case 'metal':
            path = 'metal';
            break;

        case 'electronic':
            path = 'electronic';
            break;

        case 'oldies':
            path = 'oldies';
            break;

        case 'punk':
            path = 'punk';
            break;

        case 'indie':
            path = 'indie';
            break;

        case 'jazz':
            path = 'jazz';
            break;



        default:

    }



    return path;
}




